// extracted by mini-css-extract-plugin
export var active = "_9y-7";
export var container = "_9y-0";
export var evenWidth = "_9y-4";
export var large = "_9y-5";
export var outlet = "_9y-8";
export var slide = "_9y-2";
export var small = "_9y-6";
export var tab = "_9y-3";
export var tabs = "_9y-1";